// GENERATED AUTOMATICALLY
// DON NOT EDIT IT MANUALLY

import * as React from 'react';
import AntdIcon, { AntdIconProps } from '../components/AntdIcon';
import { IconDefinition } from '../types';

const InfoOutlinedSvg: IconDefinition = {"icon":{"tag":"svg","attrs":{"fill":"none","viewBox":"0 0 24 24","focusable":"false"},"children":[{"tag":"g","attrs":{"clip-path":"url(#clip0_2421_10294)"},"children":[{"tag":"path","attrs":{"d":"M11 7h2v2h-2V7zm0 4h2v6h-2v-6zm1-9a10 10 0 100 20 10 10 0 000-20zm0 18a8.01 8.01 0 010-16 8.01 8.01 0 010 16z","fill":"currentColor"}}]},{"tag":"defs","attrs":{},"children":[{"tag":"clipPath","attrs":{"id":"clip0_2421_10294"},"children":[{"tag":"path","attrs":{"d":"M0 0h24v24H0z","fill":"currentColor"}}]}]}]},"name":"info","theme":"outlined"};

const InfoOutlined = (
  props: AntdIconProps,
  ref: React.MutableRefObject<HTMLSpanElement>,
) => <AntdIcon {...props} ref={ref} icon={InfoOutlinedSvg} />;
  InfoOutlined.displayName = 'InfoOutlined';

export default React.forwardRef<HTMLSpanElement, AntdIconProps>(InfoOutlined);
